import { autoUpdate, flip, offset, shift, useFloating } from "@floating-ui/react-dom";
import classNames from "classnames";
import type { PropsWithChildren } from "react";
import { Card } from "./Card";
import { paddingStyles, pointerStyles, positionStyles } from "./styles";
import type { PropsWithClassName } from "./types";

interface Props extends PropsWithClassName, PropsWithChildren {}
export function FloatingCard({ children, className }: Props) {
  const { refs, floatingStyles } = useFloating({
    middleware: [flip(), shift(), offset({ mainAxis: 16 })],
    whileElementsMounted: autoUpdate,
  });

  return (
    <>
      <div
        ref={refs.setReference}
        className={classNames(positionStyles.cover, positionStyles.absolute, pointerStyles.eventsNone)}
      />
      <Card ref={refs.setFloating} style={floatingStyles} className={classNames(paddingStyles.p075, className)}>
        {children}
      </Card>
    </>
  );
}
